export default {
  computationalThinking: 'Pensamiento computacional',
  globalCitizenship: 'Ciudadanía global',
  entrepreneurialSpirit: 'Espíritu emprendedor',
  krea: 'Recurso Krea',
  teachersTraining: 'Acompañamiento docente'
}

export const en = {
  computationalThinking: 'Computational thinking',
  globalCitizenship: 'Global citizenship',
  entrepreneurialSpirit: 'Entrepreneurial spirit',
  krea: 'Krea resource',
  teachersTraining: 'Teacher guidance'
}

export const ca = {
  computationalThinking: 'Pensament computacional',
  globalCitizenship: 'Ciutadania global',
  entrepreneurialSpirit: 'Esperit emprenedor',
  krea: 'Recurso Krea',
  teachersTraining: 'Acompanyament docent'
}
